import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "react-query";
import "./index.css";
import "./styles/white-label-restricar.css";
import "./styles/theme-palettes.css";
import AppRouter from "./routes/AppRouter";
import { applyWhiteLabelTheme } from "./utils/whiteLabel";
import {
  applyStoredThemePalette,
  syncThemePaletteFromHost,
} from "./utils/themePalette";
import { PermissionProvider } from "./contexts/ApplicationContext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import MapsProvider from "./components/common/query/MapsProvider";

// Antes do render para o tema já valer na primeira pintura.
applyWhiteLabelTheme();

/* Última paleta conhecida deste host, para não piscar azul antes de a cor real
   chegar. Quem tem tema por domínio em CSS não é afetado. */
applyStoredThemePalette();

/* E, em paralelo ao render, confirma a cor com o servidor a partir do domínio.
   É o que pinta a TELA DE LOGIN de um representante com domínio próprio — ali
   ainda não existe sessão, então o domínio é a única pista de quem é o dono.
   Não bloqueia o boot: a página sobe com a cor lembrada e se ajusta quando a
   resposta chega (na primeira visita àquele domínio, é a única fonte). */
syncThemePaletteFromHost();

const removeLoadingSpinner = () => {
  const loadingContainer = document.getElementById("loading-container");
  if (loadingContainer) {
    loadingContainer.style.display = "none";
  }
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
      staleTime: Infinity,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <MapsProvider>
      <PermissionProvider>
        <AppRouter />
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          draggable
          theme="light"
        />
      </PermissionProvider>
    </MapsProvider>
  </QueryClientProvider>,
);

window.addEventListener("load", removeLoadingSpinner);
